import { render, staticRenderFns } from "./LoginErp.vue?vue&type=template&id=b4b91978"
import script from "./LoginErp.vue?vue&type=script&lang=js"
export * from "./LoginErp.vue?vue&type=script&lang=js"
import style0 from "./LoginErp.vue?vue&type=style&index=0&id=b4b91978&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports